import React, { useEffect } from 'react'
import { useAuth } from '@hooks/useAuth'
import { Navigate, Outlet } from 'react-router-dom'

const AdminRouter = () => {
  const { user } = useAuth()

  const isAdmin = () => {
    return user?.authorities.includes('ROLE_ADMIN')
  }

  if (user === undefined) {
    return <>Loading</>
  }

  if (user === null || !isAdmin()) {
    return <Navigate to="/" replace={true} />
  }

  return (
    <>
      <Outlet />
    </>
  )
}

export default AdminRouter
